<template>
  <nav role="navigation">
    <ul class="nav nav-pills club-categories d-flex mb-3">
      <li class="nav-item" v-for="term in terms" :key="term.code">
        <a class="nav-link important-date-link" :class="{active: isActiveTerm(term) }" @click="changeTerm(term)"
          :title="term.description">
          {{term.description}}
        </a>
      </li>
    </ul>
  </nav>

</template>

<script>
import TermsService from "../../services/TermsService";

export default {
  name: 'ImportantDateTermNavigation',
  components: {},
  props: {
  },
  async created() {
    const termsService = new TermsService();

    try {
      const {currentTerm, terms} = await termsService.getTermsForImportantDates();

      this.activeTerm = currentTerm.term_code;

      // emit event to parent with current term code
      this.terms = terms;
      
      this.$emit('ws-load-terms', this.activeTerm);
    } catch {
      this.activeTerm = '';
      this.terms = [];

      this.$emit('ws-load-terms', this.activeTerm);

      // TODO: show error using a PrimeVue toast
      this.$emit('ws-error-load-terms');
    }

  },
  emits: [
    'ws-change-term',
    'ws-load-terms',
    'ws-error-load-terms'
  ],
  mounted() {
    this.loading = true;
  },
  data() {
    return {
      loading: false,
      terms: [
      ],
      activeTerm: '',
    };
  },
  methods: {
    isActiveTerm(term) {
      return term.term_code === this.activeTerm;
    },
    changeTerm(term) {
      this.activeTerm = term.term_code;

      // TODO: emit event
      this.$emit('ws-change-term', term.term_code);
    }
  }
}
</script>
<style scoped>
.important-date-link {
  cursor: pointer;
}
</style>